// extracted by mini-css-extract-plugin
export default {"illustration":"f0Pg9J8K"};